module.exports = __webpack_public_path__ + "static/media/notification.a5dcf9ae.mp3";